import React from "react"

function LazyLoadFallback() {
  return (
    <>
      <div className="dots-loading">
        <div></div>
      </div>
    </>
  )
}

export default LazyLoadFallback
